/* Flag che tiene traccia se ci sono ancora pagine da caricare
true | false
*/
import { createContext } from "react";
const IsLastPageContext = createContext({
    isLastPage: false,
    setIsLastPage: (isLast) => {}
  });
export default IsLastPageContext;